/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface IPayTotal
 */
export class IPayTotal {
    /**
     *
     * @type {string}
     * @memberof IPayTotal
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof IPayTotal
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof IPayTotal
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof IPayTotal
     */
    apiKey: string;
    /**
     *
     * @type {boolean}
     * @memberof IPayTotal
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof IPayTotal
     */
    autoApprove: boolean;
}
